import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mb-4 flex items-center gap-2 rounded-md border border-blue-200 bg-blue-50 px-4 py-2.5 text-sm text-blue-800"
}

import { UserGroupIcon } from '@heroicons/vue/24/outline'
import { computed, watch } from 'vue'

import api from '@/store/api'
import { mapRelationship } from '@/store/mappers'


export default {
  __name: 'ResellerBanner',
  props: {
  resellerId: { type: [String, Number], required: true },
  message: { type: String, required: true }
},
  setup(__props) {

const props = __props

const reseller = computed(() => mapRelationship({ type: 'reseller', id: String(props.resellerId) }))

watch(
  () => props.resellerId,
  id => {
    if (id && !reseller.value) {
      // Swallow failures: a merchant whose resellers capability was revoked
      // simply gets no banner rather than an unhandled rejection.
      api.call('GET', `resellers/${id}`).catch(() => {})
    }
  },
  { immediate: true }
)

return (_ctx, _cache) => {
  const _component_router_link = _resolveComponent("router-link")

  return (reseller.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_unref(UserGroupIcon), {
          class: "h-4 w-4 shrink-0 text-blue-500",
          "aria-hidden": "true"
        }),
        _createElementVNode("span", null, [
          _createTextVNode(_toDisplayString(__props.message) + " ", 1),
          _createVNode(_component_router_link, {
            to: `/resellers/${reseller.value.id}`,
            class: "font-semibold hover:underline"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(reseller.value.attributes.display_name || `Reseller #${reseller.value.id}`), 1)
            ]),
            _: 1
          }, 8, ["to"])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

}